document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

const menuButton = document.querySelector('[data-menu-button]');
const mobileMenu = document.querySelector('[data-mobile-menu]');

menuButton?.addEventListener('click', () => {
  const isOpen = menuButton.classList.toggle('is-open');
  mobileMenu?.classList.toggle('is-open', isOpen);
  menuButton.setAttribute('aria-expanded', String(isOpen));
});

mobileMenu?.querySelectorAll('a').forEach((link) => {
  link.addEventListener('click', () => {
    menuButton?.classList.remove('is-open');
    mobileMenu.classList.remove('is-open');
    menuButton?.setAttribute('aria-expanded', 'false');
  });
});

const siteChrome = document.querySelector('.site-chrome');
const announcementBar = document.querySelector('.announcement-bar');
let lastScrollY = window.scrollY;
let tickingChrome = false;

function updateAnnouncementHeight() {
  const announcementHeight = announcementBar?.offsetHeight || 0;
  const chromeHeight = siteChrome?.offsetHeight || 0;
  document.documentElement.style.setProperty('--announcement-height', `${announcementHeight}px`);
  document.documentElement.style.setProperty('--site-chrome-height', `${chromeHeight}px`);
}

function updateMobileChrome() {
  updateAnnouncementHeight();

  if (!siteChrome || !window.matchMedia('(max-width: 620px)').matches) {
    siteChrome?.classList.remove('is-hidden');
    siteChrome?.classList.remove('is-announcement-passed');
    tickingChrome = false;
    return;
  }

  const currentScrollY = window.scrollY;
  const announcementHeight = announcementBar?.offsetHeight || 0;
  const isMenuOpen = mobileMenu?.classList.contains('is-open');
  const isCartOpen = document.querySelector('[data-cart-dropdown-root].is-open');
  const isSearchOpen = document.querySelector('[data-header-search].is-open');
  const passedAnnouncement = currentScrollY > announcementHeight;

  siteChrome.classList.toggle('is-announcement-passed', passedAnnouncement);

  if (currentScrollY < 24 || isMenuOpen || isCartOpen || isSearchOpen) {
    siteChrome.classList.remove('is-hidden');
  } else if (currentScrollY > lastScrollY + 8) {
    siteChrome.classList.add('is-hidden');
  } else if (currentScrollY < lastScrollY - 6) {
    siteChrome.classList.remove('is-hidden');
  }

  lastScrollY = Math.max(0, currentScrollY);
  tickingChrome = false;
}

window.addEventListener('scroll', () => {
  if (tickingChrome) return;
  tickingChrome = true;
  window.requestAnimationFrame(updateMobileChrome);
}, { passive: true });

window.addEventListener('resize', updateMobileChrome);
updateAnnouncementHeight();

document.querySelectorAll('[data-header-search]').forEach((searchRoot) => {
  const toggle = searchRoot.querySelector('[data-header-search-toggle]');
  const input = searchRoot.querySelector('[data-header-search-input]');
  const results = searchRoot.querySelector('[data-header-search-results]');
  let searchTimer;
  let activeRequest;

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, (character) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    }[character]));
  }

  function openSearch() {
    searchRoot.classList.add('is-open');
    toggle?.setAttribute('aria-expanded', 'true');
    window.requestAnimationFrame(() => input?.focus());
  }

  function closeSearch() {
    searchRoot.classList.remove('is-open');
    toggle?.setAttribute('aria-expanded', 'false');
  }

  function renderEmpty(message) {
    if (!results) return;
    results.innerHTML = `<p class="header-search__empty">${escapeHtml(message)}</p>`;
  }

  function renderProducts(products, term) {
    if (!results) return;
    if (!products.length) {
      renderEmpty(`No products found for "${term}".`);
      return;
    }

    const productHtml = products.map((product) => {
      const image = product.image || product.featured_image || {};
      const imageUrl = typeof image === 'string' ? image : image.url || image.src;
      const imageAlt = typeof image === 'object' && image.alt ? image.alt : product.title;
      const price = product.price || product.price_min || '';
      return `
        <a class="header-search-result" href="${product.url}">
          <span class="header-search-result__media">
            ${imageUrl ? `<img src="${imageUrl}" alt="${escapeHtml(imageAlt)}" loading="lazy">` : ''}
          </span>
          <span>
            <strong>${escapeHtml(product.title)}</strong>
            ${price ? `<span>${escapeHtml(price)}</span>` : '<span>View product</span>'}
          </span>
          <span class="header-search-result__arrow" aria-hidden="true">&rarr;</span>
        </a>
      `;
    }).join('');

    results.innerHTML = `${productHtml}<a class="header-search__empty" href="/search?q=${encodeURIComponent(term)}&type=product">View all product results</a>`;
  }

  function runSearch() {
    const term = (input?.value || '').trim();
    if (term.length < 2) {
      renderEmpty('Start typing to search products.');
      return;
    }

    activeRequest?.abort();
    activeRequest = new AbortController();
    renderEmpty('Searching products...');

    fetch(`/search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=6`, {
      signal: activeRequest.signal,
      headers: { Accept: 'application/json' },
    })
      .then((response) => response.json())
      .then((data) => {
        const products = data?.resources?.results?.products || [];
        renderProducts(products, term);
      })
      .catch((error) => {
        if (error.name === 'AbortError') return;
        renderEmpty('Search is unavailable right now.');
      });
  }

  toggle?.addEventListener('click', () => {
    if (searchRoot.classList.contains('is-open')) {
      closeSearch();
      return;
    }
    openSearch();
  });

  input?.addEventListener('focus', openSearch);
  input?.addEventListener('input', () => {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(runSearch, 180);
  });

  document.addEventListener('click', (event) => {
    if (!searchRoot.contains(event.target)) closeSearch();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeSearch();
  });
});

function puroFormatMoney(cents) {
  const value = Number(cents || 0) / 100;
  return `$${value.toFixed(2)}`;
}

function puroEscapeHtml(value) {
  return String(value || '').replace(/[&<>"']/g, (character) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
  }[character]));
}

function renderCartDropdown(cart) {
  const savedExpressBlocks = [];

  document.querySelectorAll('[data-cart-dropdown-content]').forEach((content, index) => {
    const express = content.querySelector('[data-cart-express-checkout]');
    if (express) savedExpressBlocks[index] = express;
  });

  document.querySelectorAll('[data-cart-count-bubble]').forEach((bubble) => {
    const count = Number(cart?.item_count || 0);
    bubble.textContent = String(count);
    bubble.hidden = count === 0;
  });

  document.querySelectorAll('[data-cart-dropdown-content]').forEach((content, index) => {
    const items = cart?.items || [];
    if (!items.length) {
      content.innerHTML = `
        <div class="cart-dropdown__empty">
          <strong>Your cart is empty.</strong>
          <span>Add products and they will appear here.</span>
        </div>
      `;
      return;
    }

    const itemHtml = items.slice(0, 4).map((item) => `
      <div class="cart-dropdown-item">
        ${item.image ? `<img src="${item.image}" alt="${puroEscapeHtml(item.product_title)}" loading="lazy">` : '<span></span>'}
        <div>
          <strong>${puroEscapeHtml(item.product_title)}</strong>
          <span>${item.quantity} x ${puroFormatMoney(item.final_price)}</span>
        </div>
        <button class="cart-dropdown-item__remove" type="button" aria-label="Remove ${puroEscapeHtml(item.product_title)} from cart" data-cart-remove-key="${puroEscapeHtml(item.key)}">Remove</button>
      </div>
    `).join('');

    content.innerHTML = `
      <div class="cart-dropdown__head">
        <strong>Cart</strong>
        <span>${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'}</span>
      </div>
      <div class="cart-dropdown__items">${itemHtml}</div>
      <div class="cart-dropdown__summary">
        <span>Subtotal</span>
        <strong>${puroFormatMoney(cart.total_price)}</strong>
      </div>
      <div class="cart-dropdown__actions">
        <form class="cart-dropdown__checkout" action="/cart" method="post">
          <button class="button" type="submit" name="checkout" value="Checkout">Checkout</button>
        </form>
        <a class="glass-button" href="/cart">View cart</a>
      </div>
      <div data-cart-express-checkout-slot></div>
    `;

    const express = savedExpressBlocks[index];
    const expressSlot = content.querySelector('[data-cart-express-checkout-slot]');
    if (express && expressSlot) expressSlot.replaceWith(express);
  });
}

function removeCartLine(key, button) {
  if (!key) return;
  const originalText = button?.textContent;
  if (button) {
    button.disabled = true;
    button.textContent = 'Removing';
  }

  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ id: key, quantity: 0 }),
  })
    .then((response) => {
      if (!response.ok) throw new Error('Unable to remove item');
      return response.json();
    })
    .then((cart) => {
      renderCartDropdown(cart);
      maybeShowFreeShippingPopup(cart);
    })
    .catch(() => {
      if (button) {
        button.disabled = false;
        button.textContent = 'Retry';
      }
    })
    .finally(() => {
      if (button?.disabled && button.textContent === 'Removing') {
        button.textContent = originalText || 'Remove';
      }
    });
}

function maybeShowFreeShippingPopup(cart) {
  const popup = document.querySelector('[data-free-shipping-popup]');
  if (!popup || !cart) return;

  const threshold = Number(popup.dataset.threshold || 30000);
  const trigger = Number(popup.dataset.trigger || 25000);
  const total = Number(cart.total_price || 0);
  const dismissedKey = 'puro-free-shipping-popup-dismissed-v1';
  const remaining = threshold - total;
  const shouldShow = total >= trigger && total < threshold && remaining > 0;

  if (!shouldShow || sessionStorage.getItem(dismissedKey) === 'true') {
    popup.classList.remove('is-visible');
    popup.setAttribute('aria-hidden', 'true');
    return;
  }

  const message = popup.querySelector('[data-free-shipping-message]');
  const progress = popup.querySelector('[data-free-shipping-progress]');
  const percent = Math.max(0, Math.min(100, (total / threshold) * 100));

  if (message) {
    message.textContent = `You are ${puroFormatMoney(remaining)} away from free shipping.`;
  }
  if (progress) {
    progress.style.width = `${percent}%`;
  }

  popup.classList.add('is-visible');
  popup.setAttribute('aria-hidden', 'false');
}

document.querySelectorAll('[data-free-shipping-popup]').forEach((popup) => {
  const dismissedKey = 'puro-free-shipping-popup-dismissed-v1';
  popup.querySelector('[data-free-shipping-close]')?.addEventListener('click', () => {
    sessionStorage.setItem(dismissedKey, 'true');
    popup.classList.remove('is-visible');
    popup.setAttribute('aria-hidden', 'true');
  });

  popup.querySelector('[data-free-shipping-cart]')?.addEventListener('click', () => {
    const root = document.querySelector('[data-cart-dropdown-root]');
    if (root) openCartDropdown(root);
    popup.classList.remove('is-visible');
    popup.setAttribute('aria-hidden', 'true');
  });
});

function openCartDropdown(root) {
  document.querySelectorAll('[data-cart-dropdown-root]').forEach((cartRoot) => {
    const isTarget = cartRoot === root;
    cartRoot.classList.toggle('is-open', isTarget);
    cartRoot.querySelector('[data-cart-toggle]')?.setAttribute('aria-expanded', String(isTarget));
  });
}

document.querySelectorAll('[data-cart-dropdown-root]').forEach((root) => {
  const toggle = root.querySelector('[data-cart-toggle]');

  toggle?.addEventListener('click', () => {
    if (root.classList.contains('is-open')) {
      root.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      return;
    }
    openCartDropdown(root);
  });
});

document.addEventListener('click', (event) => {
  const removeButton = event.target.closest('[data-cart-remove-key]');
  if (removeButton) {
    event.preventDefault();
    removeCartLine(removeButton.dataset.cartRemoveKey, removeButton);
    return;
  }

  if (event.target.closest('[data-cart-dropdown-root]')) return;
  document.querySelectorAll('[data-cart-dropdown-root].is-open').forEach((root) => {
    root.classList.remove('is-open');
    root.querySelector('[data-cart-toggle]')?.setAttribute('aria-expanded', 'false');
  });
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('[data-cart-dropdown-root].is-open').forEach((root) => {
    root.classList.remove('is-open');
    root.querySelector('[data-cart-toggle]')?.setAttribute('aria-expanded', 'false');
  });
});

document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
  form.addEventListener('submit', (event) => {
    if (form.closest('.shopify-payment-button')) return;
    event.preventDefault();
    const submitButton = event.submitter || form.querySelector('[type="submit"]');
    const originalText = submitButton?.textContent;
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = 'Adding...';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' },
    })
      .then((response) => {
        if (!response.ok) throw new Error('Unable to add item');
        return fetch('/cart.js', { headers: { Accept: 'application/json' } });
      })
      .then((response) => response.json())
      .then((cart) => {
        renderCartDropdown(cart);
        maybeShowFreeShippingPopup(cart);
        const root = document.querySelector('[data-cart-dropdown-root]');
        if (root) openCartDropdown(root);
      })
      .catch(() => {
        if (submitButton) submitButton.textContent = 'Try again';
      })
      .finally(() => {
        window.setTimeout(() => {
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.textContent = originalText || submitButton.textContent;
          }
        }, 650);
      });
  });
});

const revealEls = document.querySelectorAll('.reveal');

if ('IntersectionObserver' in window) {
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.04, rootMargin: '0px 0px 18% 0px' });

  revealEls.forEach((el) => revealObserver.observe(el));
} else {
  revealEls.forEach((el) => el.classList.add('is-visible'));
}

document.querySelectorAll('[data-faq-item]').forEach((item) => {
  const answer = item.querySelector('[data-faq-answer]');
  if (item.classList.contains('is-open') && answer) answer.style.maxHeight = `${answer.scrollHeight}px`;

  item.querySelector('[data-faq-question]')?.addEventListener('click', () => {
    const isOpen = item.classList.contains('is-open');
    document.querySelectorAll('[data-faq-item]').forEach((other) => {
      other.classList.remove('is-open');
      const otherAnswer = other.querySelector('[data-faq-answer]');
      if (otherAnswer) otherAnswer.style.maxHeight = 0;
    });
    if (!isOpen && answer) {
      item.classList.add('is-open');
      answer.style.maxHeight = `${answer.scrollHeight}px`;
    }
  });
});

const gate = document.querySelector('[data-age-gate]');
const ageChecks = Array.from(document.querySelectorAll('[data-age-check]'));
const enterButton = document.querySelector('[data-age-enter]');
const consentKey = 'puro-age-consent-v1';

function updateAgeButton() {
  const allChecked = ageChecks.every((check) => check.checked);
  if (enterButton) enterButton.disabled = !allChecked;
}

ageChecks.forEach((check) => {
  check.addEventListener('change', updateAgeButton);
});

enterButton?.addEventListener('click', () => {
  if (!ageChecks.every((check) => check.checked)) return;
  sessionStorage.setItem(consentKey, 'true');
  document.documentElement.classList.add('age-consent-granted');
  gate?.classList.add('is-hidden');
});

if (gate && sessionStorage.getItem(consentKey) === 'true') {
  document.documentElement.classList.add('age-consent-granted');
  gate.classList.add('is-hidden');
}

document.querySelectorAll('[data-announcement-bar]').forEach((bar) => {
  const items = Array.from(bar.querySelectorAll('[data-announcement-item]'));
  const prev = bar.querySelector('[data-announcement-prev]');
  const next = bar.querySelector('[data-announcement-next]');
  if (items.length <= 1) {
    prev?.setAttribute('hidden', '');
    next?.setAttribute('hidden', '');
    return;
  }

  let activeIndex = 0;
  let timer;

  function show(index) {
    activeIndex = (index + items.length) % items.length;
    items.forEach((item, itemIndex) => {
      const active = itemIndex === activeIndex;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-hidden', String(!active));
    });
  }

  function restart() {
    clearInterval(timer);
    timer = setInterval(() => show(activeIndex + 1), 5000);
  }

  prev?.addEventListener('click', () => {
    show(activeIndex - 1);
    restart();
  });

  next?.addEventListener('click', () => {
    show(activeIndex + 1);
    restart();
  });

  restart();
});

document.querySelectorAll('[data-trust-carousel]').forEach((carousel) => {
  const cards = Array.from(carousel.children);
  if (cards.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  let activeIndex = 0;
  let timer;
  let paused = false;

  function isMobileCarousel() {
    return window.matchMedia('(max-width: 620px)').matches;
  }

  function goTo(index) {
    if (!isMobileCarousel() || paused) return;
    activeIndex = (index + cards.length) % cards.length;
    carousel.scrollTo({
      left: cards[activeIndex].offsetLeft - carousel.offsetLeft,
      behavior: 'smooth',
    });
  }

  function start() {
    window.clearInterval(timer);
    timer = window.setInterval(() => goTo(activeIndex + 1), 4200);
  }

  function pauseBriefly() {
    paused = true;
    window.clearInterval(timer);
    window.setTimeout(() => {
      paused = false;
      start();
    }, 7000);
  }

  carousel.addEventListener('pointerdown', pauseBriefly);
  carousel.addEventListener('focusin', pauseBriefly);
  carousel.addEventListener('scroll', () => {
    if (!isMobileCarousel()) return;
    const closest = cards.reduce((best, card, index) => {
      const distance = Math.abs(card.offsetLeft - carousel.scrollLeft - carousel.offsetLeft);
      return distance < best.distance ? { index, distance } : best;
    }, { index: activeIndex, distance: Infinity });
    activeIndex = closest.index;
  }, { passive: true });

  start();
});

document.querySelectorAll('[data-product-recommendations]').forEach((section) => {
  const url = section.dataset.url;
  const results = section.querySelector('[data-product-recommendations-results]');
  if (!url || !results) return;

  fetch(url)
    .then((response) => response.text())
    .then((text) => {
      const html = new DOMParser().parseFromString(text, 'text/html');
      const fetchedResults = html.querySelector('[data-product-recommendations-results]');
      if (!fetchedResults || fetchedResults.innerHTML.trim() === '') return;
      results.innerHTML = fetchedResults.innerHTML;
      results.querySelectorAll('.reveal').forEach((card) => card.classList.add('is-visible'));
    })
    .catch(() => {});
});

document.querySelectorAll('[data-cart-quantity-stepper]').forEach((stepper) => {
  const input = stepper.querySelector('[data-cart-quantity-input]');
  const minus = stepper.querySelector('[data-cart-quantity-minus]');
  const plus = stepper.querySelector('[data-cart-quantity-plus]');
  if (!input) return;

  function setQuantity(nextValue) {
    const minimum = Number(input.min || 0);
    const quantity = Math.max(minimum, Number(nextValue || minimum));
    input.value = String(quantity);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  minus?.addEventListener('click', () => setQuantity(Number(input.value || 0) - 1));
  plus?.addEventListener('click', () => setQuantity(Number(input.value || 0) + 1));
});

document.querySelectorAll('[data-product-form]').forEach((form) => {
  const variantSelect = form.querySelector('[data-variant-select]');
  const quantityInput = form.querySelector('[data-quantity-input]');
  const addButton = form.querySelector('[data-add-to-cart]');
  const productSection = form.closest('.section');
  const priceEl = productSection?.querySelector('[data-product-price]');
  const comparePriceEl = productSection?.querySelector('[data-product-compare-price]');
  const saleBadge = productSection?.querySelector('[data-product-sale-badge]');
  const stockIndicator = productSection?.querySelector('[data-stock-indicator]');
  const stockLabel = productSection?.querySelector('[data-stock-label]');
  const sticky = productSection?.querySelector('[data-sticky-atc]');
  const stickyPrice = sticky?.querySelector('[data-sticky-price]');
  const stickyButton = sticky?.querySelector('[data-sticky-submit]');
  const discount = form.querySelector('[data-quantity-discount]');
  const discountMessage = discount?.querySelector('[data-quantity-discount-message]');
  const discountFill = discount?.querySelector('[data-quantity-discount-fill]');
  const quantityMinus = form.querySelector('[data-quantity-minus]');
  const quantityPlus = form.querySelector('[data-quantity-plus]');

  function selectedOption() {
    return variantSelect?.selectedOptions?.[0] || form.querySelector('input[name="id"]');
  }

  function formatMoney(cents, template) {
    const numeric = (Number(cents || 0) / 100).toFixed(2);
    const source = template || '$0.00';
    const match = source.match(/^([^0-9-]*).+?([^0-9]*)$/);
    const prefix = match?.[1] || '$';
    const suffix = match?.[2] || '';
    return `${prefix}${numeric}${suffix}`;
  }

  function discountPercentForQuantity(quantity) {
    if (!discount) return 0;
    const thresholdOne = Number(discount.dataset.thresholdOne || 2);
    const thresholdTwo = Number(discount.dataset.thresholdTwo || 3);
    const percentOne = Number(discount.dataset.discountPercentOne || 0);
    const percentTwo = Number(discount.dataset.discountPercentTwo || 0);
    if (quantity >= thresholdTwo) return percentTwo;
    if (quantity >= thresholdOne) return percentOne;
    return 0;
  }

  function updateStock(option) {
    if (!stockIndicator || !stockLabel) return;
    const available = option?.dataset.available !== 'false';
    const inventoryManagement = option?.dataset.inventoryManagement;
    const inventoryQuantity = Number(option?.dataset.inventoryQuantity || 0);
    const lowStockThreshold = Number(productSection?.querySelector('[data-low-stock-threshold]')?.dataset.lowStockThreshold || 5);
    let status = 'In stock';
    let className = 'stock-indicator stock-indicator--in-stock';
    if (!available) {
      status = 'Out of stock';
      className = 'stock-indicator stock-indicator--out-of-stock';
    } else if (inventoryManagement && inventoryQuantity <= lowStockThreshold) {
      status = 'Low stock';
      className = 'stock-indicator stock-indicator--low-stock';
    }
    stockLabel.textContent = status;
    stockIndicator.className = className;
  }

  function updatePrice() {
    const option = selectedOption();
    const formatted = option?.dataset.priceFormatted;
    const price = Number(option?.dataset.price || 0);
    const comparePrice = Number(option?.dataset.comparePrice || 0);
    const compareFormatted = option?.dataset.comparePriceFormatted;
    const available = option?.dataset.available !== 'false';
    const quantity = Math.max(1, Number(quantityInput?.value || 1));
    const quantityDiscount = discountPercentForQuantity(quantity);
    const discountedUnitPrice = Math.round(price * (1 - quantityDiscount / 100));
    const totalPrice = discountedUnitPrice * quantity;
    const originalUnitPrice = comparePrice > price ? comparePrice : price;
    const originalTotalPrice = originalUnitPrice * quantity;
    const hasSavings = originalTotalPrice > totalPrice;

    if (formatted && priceEl) priceEl.textContent = formatMoney(totalPrice, formatted);
    if (comparePriceEl) {
      comparePriceEl.textContent = formatMoney(originalTotalPrice, compareFormatted || formatted);
      comparePriceEl.hidden = !hasSavings;
    }
    if (saleBadge) {
      saleBadge.hidden = !hasSavings;
      saleBadge.textContent = quantityDiscount > 0 ? `Save ${quantityDiscount}%` : 'Sale';
    }
    if (formatted && stickyPrice) stickyPrice.textContent = formatMoney(totalPrice, formatted);
    if (addButton) addButton.disabled = !available;
    if (stickyButton) stickyButton.disabled = !available;
    updateStock(option);
  }

  function updateDiscount() {
    if (!discount || !quantityInput) return;
    const quantity = Math.max(1, Number(quantityInput.value || 1));
    const thresholdOne = Number(discount.dataset.thresholdOne || 2);
    const thresholdTwo = Number(discount.dataset.thresholdTwo || 3);
    const progress = Math.min(100, (quantity / thresholdTwo) * 100);
    if (discountFill) discountFill.style.width = `${progress}%`;
    if (!discountMessage) return;
    const percentOne = Number(discount.dataset.discountPercentOne || 0);
    const percentTwo = Number(discount.dataset.discountPercentTwo || 0);
    if (quantity >= thresholdTwo) {
      discountMessage.textContent = `${percentTwo}% off for 3+ items`;
    } else if (quantity >= thresholdOne) {
      discountMessage.textContent = `${percentOne}% off for buying 2. Buy 3+ for ${percentTwo}% off`;
    } else {
      discountMessage.textContent = `Buy 2 for ${percentOne}% off, or 3+ for ${percentTwo}% off`;
    }
  }

  variantSelect?.addEventListener('change', updatePrice);
  quantityInput?.addEventListener('input', () => {
    updateDiscount();
    updatePrice();
  });
  quantityMinus?.addEventListener('click', () => {
    if (!quantityInput) return;
    quantityInput.value = Math.max(1, Number(quantityInput.value || 1) - 1);
    quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
  });
  quantityPlus?.addEventListener('click', () => {
    if (!quantityInput) return;
    quantityInput.value = Number(quantityInput.value || 1) + 1;
    quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
  });
  stickyButton?.addEventListener('click', () => addButton?.click());

  if (sticky && addButton && 'IntersectionObserver' in window) {
    const stickyObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        sticky.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0, rootMargin: '0px 0px -12% 0px' });
    stickyObserver.observe(addButton);
  }

  updatePrice();
  updateDiscount();
});

document.querySelectorAll('[data-lab-grid]').forEach((grid) => {
  const section = grid.closest('.lab-results');
  const search = section?.querySelector('[data-lab-search]');
  const category = section?.querySelector('[data-lab-category]');
  const empty = section?.querySelector('[data-lab-empty]');
  const sort = section?.querySelector('[data-lab-sort]');
  const count = section?.querySelector('[data-lab-count]');
  const cards = Array.from(grid.querySelectorAll('[data-lab-card]'));

  function filterCards() {
    const term = (search?.value || '').trim().toLowerCase();
    const selectedCategory = category?.value || 'all';
    const visibleCards = cards.filter((card) => {
      const matchesTerm = !term || (card.dataset.search || '').includes(term);
      const matchesCategory = selectedCategory === 'all' || card.dataset.category === selectedCategory;
      return matchesTerm && matchesCategory;
    });

    const sortMode = sort?.value || 'newest';
    visibleCards.sort((a, b) => {
      if (sortMode === 'oldest') return Number(a.dataset.sortDate || 0) - Number(b.dataset.sortDate || 0);
      if (sortMode === 'purity-high') return Number(b.dataset.purity || 0) - Number(a.dataset.purity || 0);
      if (sortMode === 'name-az') return (a.dataset.name || '').localeCompare(b.dataset.name || '');
      return Number(b.dataset.sortDate || 0) - Number(a.dataset.sortDate || 0);
    });

    cards.forEach((card) => card.classList.add('is-hidden'));
    visibleCards.forEach((card) => {
      card.classList.remove('is-hidden');
      grid.appendChild(card);
    });

    if (count) count.textContent = visibleCards.length;
    if (empty) empty.hidden = visibleCards.length !== 0;
  }

  search?.addEventListener('input', filterCards);
  category?.addEventListener('change', filterCards);
  sort?.addEventListener('change', filterCards);
  filterCards();
});

document.querySelectorAll('[data-recon-calculator]').forEach((calculator) => {
  const vialInput = calculator.querySelector('[data-recon-vial]');
  const vialUnit = calculator.querySelector('[data-recon-vial-unit]');
  const waterInput = calculator.querySelector('[data-recon-water]');
  const doseInput = calculator.querySelector('[data-recon-dose]');
  const doseUnit = calculator.querySelector('[data-recon-dose-unit]');
  const syringeSizes = Array.from(calculator.querySelectorAll('[data-recon-syringe-size]'));
  const syringe = calculator.querySelector('.recon-syringe');
  const liquid = calculator.querySelector('[data-recon-syringe-liquid]');
  const scale = calculator.querySelector('[data-recon-scale]');
  const unitsOutput = calculator.querySelector('[data-recon-units]');
  const volumeOutput = calculator.querySelector('[data-recon-volume]');
  const concentrationOutput = calculator.querySelector('[data-recon-concentration]');
  const concentrationMcgOutput = calculator.querySelector('[data-recon-concentration-mcg]');
  const doseVolumeOutput = calculator.querySelector('[data-recon-dose-volume]');
  const doseUlOutput = calculator.querySelector('[data-recon-dose-ul]');
  const dosesOutput = calculator.querySelector('[data-recon-doses]');
  const doseNote = calculator.querySelector('[data-recon-dose-note]');
  const error = calculator.querySelector('[data-recon-error]');

  function numberFrom(input) {
    return Number(input?.value || 0);
  }

  function selectedSyringeMl() {
    const selected = syringeSizes.find((input) => input.checked);
    return Number(selected?.value || 1);
  }

  function formatNumber(value, decimals = 2) {
    if (!Number.isFinite(value)) return '0';
    return value.toLocaleString('en-AU', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });
  }

  function formatFlexible(value) {
    if (!Number.isFinite(value)) return '0';
    const decimals = value >= 10 ? 0 : value >= 1 ? 1 : 2;
    return value.toLocaleString('en-AU', {
      minimumFractionDigits: 0,
      maximumFractionDigits: decimals,
    });
  }

  function setText(element, value) {
    if (element) element.textContent = value;
  }

  function updateScale(maxUnits) {
    if (!scale) return;
    const step = maxUnits / 5;
    scale.innerHTML = Array.from({ length: 6 }, (_, index) => {
      const value = Math.round(step * index);
      return `<span>${value}</span>`;
    }).join('');
  }

  function calculate() {
    const vialAmount = numberFrom(vialInput);
    const waterMl = numberFrom(waterInput);
    const doseAmount = numberFrom(doseInput);
    const vialMcg = vialUnit?.value === 'mcg' ? vialAmount : vialAmount * 1000;
    const doseMcg = doseUnit?.value === 'mg' ? doseAmount * 1000 : doseAmount;
    const syringeMl = selectedSyringeMl();
    const maxUnits = syringeMl * 100;
    const valid = vialMcg > 0 && waterMl > 0 && doseMcg > 0 && maxUnits > 0;

    if (!valid) {
      if (error) {
        error.hidden = false;
        error.textContent = 'Enter valid positive numbers to calculate.';
      }
      return;
    }

    const concentrationMcgMl = vialMcg / waterMl;
    const concentrationMgMl = concentrationMcgMl / 1000;
    const doseVolumeMl = doseMcg / concentrationMcgMl;
    const doseVolumeUl = doseVolumeMl * 1000;
    const units = doseVolumeMl * 100;
    const dosesPerVial = vialMcg / doseMcg;
    const drawPercent = Math.max(0, Math.min(100, (units / maxUnits) * 100));
    const plungerOffset = Math.max(0, Math.min(28, drawPercent * 0.28));

    updateScale(maxUnits);
    setText(unitsOutput, formatFlexible(units));
    setText(volumeOutput, formatNumber(doseVolumeMl, 2));
    setText(concentrationOutput, formatNumber(concentrationMgMl, 2));
    setText(concentrationMcgOutput, formatNumber(concentrationMcgMl, 0));
    setText(doseVolumeOutput, formatNumber(doseVolumeMl, 2));
    setText(doseUlOutput, formatNumber(doseVolumeUl, 0));
    setText(dosesOutput, formatFlexible(dosesPerVial));

    if (doseNote) {
      doseNote.textContent = Number.isInteger(dosesPerVial) ? 'exact' : 'approximate';
    }

    if (syringe) {
      syringe.style.setProperty('--draw-percent', `${drawPercent}%`);
      syringe.style.setProperty('--plunger-offset', `${plungerOffset}px`);
    }
    if (liquid) {
      liquid.style.width = `${drawPercent}%`;
    }

    if (error) {
      const exceedsSyringe = units > maxUnits;
      error.hidden = !exceedsSyringe;
      error.textContent = exceedsSyringe
        ? `Draw volume exceeds the selected ${syringeMl} ml syringe capacity.`
        : '';
    }
  }

  [vialInput, vialUnit, waterInput, doseInput, doseUnit, ...syringeSizes].forEach((element) => {
    element?.addEventListener('input', calculate);
    element?.addEventListener('change', calculate);
  });

  calculate();
});

document.querySelectorAll('[data-collection-filter]').forEach((toolbar) => {
  const section = toolbar.closest('.section');
  const grid = section?.querySelector('[data-collection-grid]');
  const cards = Array.from(grid?.querySelectorAll('[data-product-card]') || []);
  const pagination = grid?.querySelector('nav[aria-label="Pagination"]');
  const toggle = toolbar.querySelector('[data-filter-toggle]');
  const filterWrap = toolbar.querySelector('.collection-filter');
  const menu = toolbar.querySelector('[data-filter-menu]');
  const options = Array.from(toolbar.querySelectorAll('[data-filter-option]'));
  const count = toolbar.querySelector('[data-collection-count]');
  const empty = section?.querySelector('[data-collection-empty]');

  function labelFor(total) {
    return `${total} ${total === 1 ? 'product' : 'products'}`;
  }

  function closeMenu() {
    filterWrap?.classList.remove('is-open');
    toggle?.setAttribute('aria-expanded', 'false');
  }

  function applyFilter(filter) {
    const visibleCards = cards.filter((card) => {
      const available = card.dataset.available === 'true';
      const sale = card.dataset.sale === 'true';
      return filter === 'all'
        || (filter === 'available' && available)
        || (filter === 'sale' && sale)
        || (filter === 'soldout' && !available);
    });

    cards.forEach((card) => {
      const isVisible = visibleCards.includes(card);
      card.classList.toggle('is-filter-hidden', !isVisible);
      card.hidden = !isVisible;
      card.setAttribute('aria-hidden', String(!isVisible));
    });

    visibleCards.forEach((card) => grid?.appendChild(card));
    if (pagination) grid?.appendChild(pagination);

    if (count) count.textContent = labelFor(visibleCards.length);
    if (empty) empty.hidden = visibleCards.length !== 0;
    options.forEach((option) => {
      option.classList.toggle('is-active', option.dataset.filterOption === filter);
    });
  }

  toggle?.addEventListener('click', () => {
    const isOpen = filterWrap?.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(Boolean(isOpen)));
  });

  options.forEach((option) => {
    option.addEventListener('click', () => {
      applyFilter(option.dataset.filterOption || 'all');
      closeMenu();
    });
  });

  document.addEventListener('click', (event) => {
    if (!toolbar.contains(event.target)) closeMenu();
  });

  menu?.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeMenu();
      toggle?.focus();
    }
  });
});

document.querySelectorAll('[data-coa-modal]').forEach((modal) => {
  const title = modal.querySelector('#coa-modal-title');
  const image = modal.querySelector('[data-coa-image]');
  const frame = modal.querySelector('[data-coa-frame]');
  const link = modal.querySelector('[data-coa-link]');

  function close() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (image) image.hidden = true;
    if (frame) frame.hidden = true;
  }

  modal.querySelectorAll('[data-close-coa]').forEach((button) => {
    button.addEventListener('click', close);
  });

  document.querySelectorAll('[data-open-coa]').forEach((button) => {
    button.addEventListener('click', () => {
      const url = button.dataset.url;
      if (!url) return;
      if (title) title.textContent = button.dataset.title || 'COA Preview';
      if (link) link.href = url;
      const isImage = /\.(jpeg|jpg|png|webp|gif)(\?|$)/i.test(url);
      if (image) {
        image.hidden = !isImage;
        if (isImage) image.src = url;
      }
      if (frame) {
        frame.hidden = isImage;
        if (!isImage) frame.src = url;
      }
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    });
  });
});
